import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 关联资源类型聚合查询
export function aggregationResouceType(params) {
    return request({
        baseURL,
        url: '/emergencyEvent/aggregationResouceType',
        method: 'get',
        params
    })
}
// 新增应急事件
export function executeTask(data) {
    return request({
        baseURL,
        url: '/emergencyEvent/executeTask',
        method: 'post',
        data
    })
}
// 新增应急事件
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyEvent/save',
        method: 'post',
        data
    })
}
//修改应急事件
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyEvent/update',
        method: 'post',
        data
    })
}
//查询应急事件列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyEvent/list',
        method: 'get',
        params
    })
}
//查询应急事件
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyEvent/detail?id=' + id,
        method: 'get',
    })
}
//删除应急事件
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyEvent/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}